import { createAction, props } from '@ngrx/store';
import { Contact, UserProfile } from '@qvs/core';

const prefix = `[User]`;

export const loadUserProfile = createAction(`${prefix} Load User Profile`);

export const loadUserProfileSuccess = createAction(`${prefix} Load User Profile Success`, props<{ userProfile: UserProfile }>());

export const loadUserProfileFailure = createAction(`${prefix} Load User Profile Failure`);

export const checkUserSessionIsActive = createAction(`${prefix} Check User Session Is Active`);

export const checkUserSessionIsActiveSuccess = createAction(`${prefix} Check User Session Is Active Success`);

export const checkUserSessionIsActiveFailure = createAction(`${prefix} Check User Session Is Active Failure`);

export const updateCrmSuccess = createAction(`${prefix} Update Crm Success`, props<{ userProfile: UserProfile }>());

export const setCurrentClient = createAction(`${prefix} Set Current Client`, props<{ client: Contact }>());

export const clearCurrentClient = createAction(`${prefix} Clear Current Client`);
